import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import './styles.css'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import logo from '../../assets/images/logo.jpeg';
import * as mui from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import Cookies from 'js-cookie'
import { useNavigate } from 'react-router-dom';  
import AuthService from '../../services/AuthService';

// Custom styled tooltip
const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: '#333',
    color: '#fff',
    fontSize: 12,
    padding: '6px 12px',
    borderRadius: 4,
    marginLeft: 5,
    borderLeft: '3px solid #0288d1',
    boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
    zIndex: 9999, // Ensure tooltip is above all elements
  },
  [`& .MuiTooltip-arrow`]: {
    color: '#333',
  },
  // Make sure the popper receives events
  pointerEvents: 'auto',
}));

// Styled list item to fix issues with tooltips on li elements
const StyledListItem = styled('li')({
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  height: '48px',
  width: '100%',
});

const SideBar = ({ mainContent }) => {
    const [drawerPos, setDrawerPos] = useState(1);
    const navigate = useNavigate();

    const handleDrawer = () => {
        if (drawerPos < 2) {
            setDrawerPos(drawerPos + 1);
        } else {
            setDrawerPos(0);
        }
    };

    const handleLogout = async () => {
        try {
            // AuthService.logout handles both server-side and client-side logout
            await AuthService.logout();
            
            // Note: AuthService.logout already redirects to /loginform
            // But we can override to navigate to /login if needed
            navigate('/login');
        } catch (error) {
            console.error('Error during logout:', error);
            navigate('/login');
        }
    };

    const handleHome = () => {
        navigate('/Dashboard');
    };

    const handleInterface = () => {
        navigate('/Interfaces');
    };

    const handleSecurity = () => {
        navigate('/Security');
    };

    let drawerClass = [];
    let mainClass = [];

    if (drawerPos === 1) {
        drawerClass.push('drawerMin');
        mainClass.push('mainMin');
    } else if (drawerPos === 2) {
        drawerClass.push('drawerOpen');
        mainClass.push('mainOpen');
    } else {
        drawerClass = [];
        mainClass = [];
    }

    // Check if drawer is currently minimized (for tooltips)
    const isDrawerMinimized = drawerPos === 1;

    return (
        <div className="mx-auto max-w-7xl sm:px-6 lg:px-8">{
            
            <div className="App">
            <navbar>
                <i className="material-icons" onClick={handleDrawer}>
                    menu
                </i>
            
                <a className="navbar-brand" href="/" style={{ marginLeft: '10px' }}>
                    <img src={logo} width="35" height="35" className="d-inline-block align-top" alt="" />
                    <span className="menu-collapsed" style={{ marginLeft: '10px', fontSize: '25px', color: 'white' }}>Audit-AI</span>
                </a>
            </navbar>
            <aside className={drawerClass.join(' ')}>
                <ul>
                    {isDrawerMinimized ? (
                        // For minimized drawer, show tooltips
                        <>
                            <StyledTooltip title="Dashboard" placement="right" arrow>
                                <StyledListItem onClick={handleHome} className="sidebar-item">
                                    <i className="material-icons">dashboard</i>
                                    <span>Dashboard</span>
                                </StyledListItem>
                            </StyledTooltip>
                            <StyledTooltip title="Manage System" placement="right" arrow>
                                <StyledListItem onClick={handleSecurity} className="sidebar-item">
                                    <i className="material-icons">settings</i>
                                    <span>Manage System</span>
                                </StyledListItem>
                            </StyledTooltip>
                            <StyledTooltip title="Jobs" placement="right" arrow>
                                <StyledListItem onClick={handleInterface} className="sidebar-item">
                                    <i className="material-icons">monitor</i>
                                    <span>Jobs</span>
                                </StyledListItem>
                            </StyledTooltip>
                            <StyledTooltip title="Logout" placement="right" arrow>
                                <StyledListItem onClick={handleLogout} className="sidebar-item">
                                    <i className="material-icons">logout</i>
                                    <span>Logout</span>
                                </StyledListItem>
                            </StyledTooltip>
                        </>
                    ) : (
                        // For expanded drawer, no tooltips needed
                        <>
                            <StyledListItem onClick={handleHome} className="sidebar-item">
                                <i className="material-icons">dashboard</i>
                                <span>Dashboard</span>
                            </StyledListItem>
                            <StyledListItem onClick={handleSecurity} className="sidebar-item">
                                <i className="material-icons">settings</i>
                                <span>Manage System</span>
                            </StyledListItem>
                            <StyledListItem onClick={handleInterface} className="sidebar-item">
                                <i className="material-icons">monitor</i>
                                <span>Jobs</span>
                            </StyledListItem>
                            <StyledListItem onClick={handleLogout} className="sidebar-item">
                                <i className="material-icons">logout</i>
                                <span>Logout</span>
                            </StyledListItem>
                        </>
                    )}
                </ul>
            </aside>

        <main className={mainClass.join(' ')}>
          {mainContent}
        </main>

            </div>

        }
        </div>
    );
};

export default SideBar;
